<!--
 * @Author: 仙道
 * @Date: 2022-06-06 22:42:26
 * @LastEditTime: 2022-06-07 18:24:18
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/tech/assay/module/table.vue
-->
<template>
  <div class="p-20px">
    <a-button size="mini" type="small">新增</a-button>
    <a-table
      :columns="columns"
      :dataSource="dataSource"
      :loading="loading"
      :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
      :scroll="{x:true}"
      @change="handleTableChange"
      bordered
      class="j-table-force-nowrap mt-10px"
      ref="table"
      rowKey="id"
      size="middle"
    >
      <template slot="htmlSlot" slot-scope="text">
        <div v-html="text"></div>
      </template>
      <template slot="imgSlot" slot-scope="text">
        <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
        <img
          :src="getImgView(text)"
          alt
          height="25px"
          style="max-width:80px;font-size: 12px;font-style: italic;"
          v-else
        />
      </template>
      <template slot="fileSlot" slot-scope="text">
        <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
        <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
      </template>

      <span slot="action" slot-scope="text, record">
        <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
          <a>删除</a>
        </a-popconfirm>
      </span>
    </a-table>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'AssayTable',
    components: {

    },
    // 定义属性
    data () {
      return {
        columns: [{
          title: '样品名称',
          align: 'center',
          dataIndex: 'devId'
        },
        {
          title: '化验项目',
          align: 'center',
          dataIndex: 'docName'
        },
        {
          title: '计量单位',
          align: 'center',
          dataIndex: 'docName'
        },
        {
          title: '指标级别',
          align: 'center',
          dataIndex: 'docName'
        },
        {
          title: '阈值上限',
          align: 'center',
          dataIndex: 'docName'
        },
        {
          title: '阈值下限',
          align: 'center',
          dataIndex: 'docName'
        },

        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }],
        dataSource: [],

        loading: false,
        /* table选中keys */
        selectedRowKeys: [],
        /* table选中records */
        selectionRows: [],
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      onSelectChange () { },
      handleTableChange () { }
    }
  }
</script>

<style lang='scss' scoped>


</style>